import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Divider, MenuItem, Grid, InputLabel, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, FormControlLabel } from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import tokenDecoder from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik, Form } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import DeleteIcon from '@material-ui/icons/Delete';
import { AlertDialogWithoutButton } from 'src/views/Common/AlertDialogWithoutButton';
import EditIcon from '@material-ui/icons/Edit';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import { Autocomplete } from '@material-ui/lab';
import c from 'react-multiple-select-dropdown-lite';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    table: {
        minWidth: 550,
    },

    green: {
        backgroundColor: 'green'
    },

    red: {
        backgroundColor: 'red'
    }
}));

const screenCode = "ITEMREQUISITION"

export default function RequisitionAddEdit() {

    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    let decryptedID = 0;
    const { requisitionID } = useParams();
    const [title, setTitle] = useState("Add Requisition")
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [dialogbox, setDialogbox] = useState(false);
    const [index, setIndex] = useState(0);
    const [row, setRow] = useState(0);
    const [decryptedIDD, setDecryptedID] = useState();
    const [requisitionDetailsID, setReuisitionDetailsID] = useState(0);
    const [SKUCategoryNames, setSKUCategoryNames] = useState();
    const [item, setItem] = useState([]);
    const [skuMaster, setSkuMaster] = useState([]);
    const [deliveryWarehouses, setDeliveryWarehouses] = useState([]);
    const [warehouse, setWarehouse] = useState([]);
    const [types, setTypes] = useState([]);
    const [budgetCodes, setBudgetCodes] = useState([]);
    const [purchaseTypes, setPurchaseTypes] = useState([]);
    const [date, setDate] = useState(new Date());
    const [expectedDate, setExpectedDate] = useState(new Date());
    const [isUpdate, setIsUpdate] = useState(false);
    const [isUpdate2, setIsUpdate2] = useState(false);
    const [gridDatArray, setGridDatArray] = useState([]);
    const [requisitionNumber, setRequisitionNumber] = useState('');
    const [availableQuantity, setAvailableQuantity] = useState('');
    const [estateName, setEstateName] = useState('');
    const [enteredByUser, setEnteredByUser] = useState('');
    const [checkedByUser, setCheckedByUser] = useState('');
    const [requisitionStatus, setRequisitionStatus] = useState(0);
    const [requisitionDetails, setRequisitionDetails] = useState({
        groupID: '0',
        factoryID: '0',
        skuCategoryID: '0',
        itemName: '0',
        deliveryWarehouseID: '0',
        requestAmount: '',
        department: '0',
        budgetCodeID: '0',
        isUrgent: false,
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isApproveEnabled: false,
        isSendToApproveEnabled: false,
        isRejectEnabled: false,
        isUpdateEnabled: false,
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: "",
        estateName: "",
        warehouseName: "",
        requestDate: "",
        requisitionNumber: "",
        budgetName: "",
        isUrgent: "",
    })

    const componentRef = useRef();

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermissions(),
            getTypesForDropDown(), getBudgetCodeDetails()
        );
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropdown(), getPurchaseTypesForDropdown());
    }, [requisitionDetails.groupID]);

    useEffect(() => {
        if (parseInt(requisitionDetails.skuCategoryID) != 0 && parseInt(requisitionDetails.factoryID) != 0)
            trackPromise(
                getItemByItemCategoryForDropDown()
            );
    }, [requisitionDetails.budgetCodeID, requisitionDetails.skuCategoryID])

    useEffect(() => {
        trackPromise(getDeliveryWarehousesForDropdownByID());
    }, [requisitionDetails.skuCategoryID, requisitionDetails.itemName]);

    useEffect(() => {
        if (requisitionDetails.budgetCodeID > 0 || isUpdate) {
            trackPromise(getSKUCategoryNamesForDropdown());
        };
    }, [requisitionDetails.budgetCodeID]);

    useEffect(() => {
        trackPromise(
            GetWarehousesByGroupIDAndFactoryID()
        );
    }, [requisitionDetails.groupID, requisitionDetails.factoryID])

    useEffect(() => {
        const decryptedEditID = atob(requisitionID.toString());

        if (
            requisitionDetails.groupID != 0 &&
            requisitionDetails.factoryID != 0 &&
            !isUpdate &&
            decryptedEditID == 0
        ) {
            trackPromise(
                generateRequisitionNumber()
            );
        }
    }, [requisitionDetails.groupID, requisitionDetails.factoryID, date]);

    useEffect(() => {
        if (!isUpdate2 && parseInt(requisitionDetails.itemName) != 0) {
            trackPromise(
                getAvailableQuantity()
            );
        }
    }, [requisitionDetails.itemName])

    useEffect(() => {
        decryptedID = atob(requisitionID.toString());
        if (decryptedID != 0) {
            trackPromise(getDetailsByRequisitionID(decryptedID));
            setDecryptedID(decryptedID)
        }
    }, []);

    useEffect(() => {
        if (!isUpdate) {
            setRequisitionDetails({
                ...requisitionDetails,
                factoryID: '0',
                skuCategoryID: '0',
                itemName: '0',
                deliveryWarehouseID: '0',
                requestAmount: '',
                budgetCodeID: '0',
                isUrgent: false,
            })
            setGridDatArray([]);
            setDate(new Date());
            setExpectedDate(new Date());
            setRequisitionNumber('');
            setAvailableQuantity('');
        }
    }, [requisitionDetails.groupID])

    useEffect(() => {
        if (!isUpdate) {
            setRequisitionDetails({
                ...requisitionDetails,
                skuCategoryID: '0',
                itemName: '0',
                deliveryWarehouseID: '0',
                requestAmount: '',
                budgetCodeID: '0',
                isUrgent: false,
            })
            setGridDatArray([]);
            setDate(new Date());
            setExpectedDate(new Date());
            setRequisitionNumber('');
            setAvailableQuantity('');
        }
    }, [requisitionDetails.factoryID])

    useEffect(() => {
        if (!isUpdate) {
            setRequisitionDetails({
                ...requisitionDetails,
                skuCategoryID: '0',
                itemName: '0',
                deliveryWarehouseID: '0',
                requestAmount: '',
                isUrgent: false,
            })
            setGridDatArray([]);
            setAvailableQuantity('');
        }
    }, [requisitionDetails.budgetCodeID])


    useEffect(() => {
        if (!isUpdate2) {
            setRequisitionDetails({
                ...requisitionDetails,
                itemName: '0',
                deliveryWarehouseID: '0',
                requestAmount: '',

            })
            setAvailableQuantity('');
        }
    }, [requisitionDetails.skuCategoryID])

    useEffect(() => {
        if (!isUpdate2) {
            setRequisitionDetails({
                ...requisitionDetails,
                deliveryWarehouseID: '0',
                requestAmount: '',
            })
            setAvailableQuantity('');
        }
    }, [requisitionDetails.itemName])

    useEffect(() => {
        if (!isUpdate && !isUpdate2) {
            setRequisitionDetails({
                ...requisitionDetails,
                requestAmount: '',
            })
        }
    }, [requisitionDetails.deliveryWarehouseID])

    useEffect(() => {
        if (deliveryWarehouses && Object.keys(deliveryWarehouses).length > 0 && !isUpdate2 && (parseInt(requisitionDetails.itemName) > 0)) {
            const firstKey = Object.keys(deliveryWarehouses)[0];
            setRequisitionDetails(prev => ({
                ...prev,
                deliveryWarehouseID: firstKey
            }));
        }
    }, [deliveryWarehouses, isUpdate2]);

    useEffect(() => {
        decryptedID = atob(requisitionID.toString());
        if (decryptedID != 0) {
            setDecryptedID(decryptedID)
        }
    }, [requisitionID]);

    useEffect(() => {
        if (requisitionDetails.budgetCodeID == 0) {
            setSKUCategoryNames()
        }
    }, [requisitionDetails.budgetCodeID])

    const handleClick = () => {
        navigate('/app/itemRequisition/listing');
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDITEMREQUISITION');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        var isSendToApproveEnabled = permissions.find(p => p.permissionCode == 'SENDTOAPPROVEREQUISITION');
        var isApproveEnabled = permissions.find(p => p.permissionCode == 'APPROVEREQUISITION');
        var isRejectEnabled = permissions.find(p => p.permissionCode == 'REJECTREQUISITION');
        var isUpdateEnabled = permissions.find(p => p.permissionCode == 'UPDATEREQUISITION');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isSendToApproveEnabled: isSendToApproveEnabled !== undefined,
            isApproveEnabled: isApproveEnabled !== undefined,
            isRejectEnabled: isRejectEnabled !== undefined,
            isUpdateEnabled: isUpdateEnabled !== undefined,

        });

        setRequisitionDetails({
            ...requisitionDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken()) 
        })
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropdown() {
        const factories = await services.getAllFactoriesByGroupID(requisitionDetails.groupID);
        setFactories(factories);
    }

    async function getBudgetCodeDetails() {
        var response = await services.getBudgetCodeDetails();
        setBudgetCodes(response);
    }

    async function getPurchaseTypesForDropdown() {
        var response = await services.getPurchaseTypesForDropdown();
        setPurchaseTypes(response);
    }

    async function getSKUCategoryNamesForDropdown() {
        const SKUCategoryNames = await services.GetSKUCategoryNamesByID(requisitionDetails.budgetCodeID, requisitionDetails.groupID);
        setSKUCategoryNames(SKUCategoryNames);
    }

    async function GetWarehousesByGroupIDAndFactoryID() {
        var res = await services.GetWarehousesByGroupIDAndFactoryID(requisitionDetails.groupID, requisitionDetails.factoryID);
        setWarehouse(res);
    }

    async function getItemByItemCategoryForDropDown() {
        var res = await services.getItemByItemCategoryForDropDown(requisitionDetails.budgetCodeID, requisitionDetails.skuCategoryID, requisitionDetails.factoryID);
        setItem(res.skuItemArray);
        setSkuMaster(res.response)
    }

    async function getDeliveryWarehousesForDropdownByID() {
        var res = await services.getDeliveryWarehousesForDropdownByID(requisitionDetails.itemName);
        setDeliveryWarehouses(res);
    }
    async function getTypesForDropDown() {
        var res = await services.getSKUTypesForDropDown();
        setTypes(res);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    const generateFactoryDropDownMenu = (data) => {
        return data ? data.map(({ id, name }) => (
            <MenuItem key={id} value={id}>{name}</MenuItem>
        )) : [];
    };

    function handleChange(e) {
        const target = e.target;
        const value = target.value

        setRequisitionDetails({
            ...requisitionDetails,
            [e.target.name]: value
        });
    }

    async function getDetailsByRequisitionID(requisitionID) {
        let response = await services.getDetailsByRequisitionID(requisitionID);
        setIsUpdate(true);
        let data = {
            groupID: response.data.groupID,
            factoryID: response.data.factoryID,
            budgetCodeID: response.data.budgetCodeID,
            isUrgent: response.data.isUrgent,
        }
        setRequisitionStatus(response.data.requisitionStatus);
        setDate(new Date(response.data.requestDate))
        setExpectedDate(new Date(response.data.expectedDate))
        setRequisitionNumber(response.data.requisitionNumber)
        setGridDatArray(response.data.requisitionDetails)
        setEstateName(response.data.factoryName)
        setReuisitionDetailsID(response.data.requisitionDetails[0].requisitionDetailsID)
        setRequisitionDetails({
            ...requisitionDetails,
            groupID: response.data.groupID,
            factoryID: response.data.factoryID,
            requestDate: response.data.requestDate,
            budgetCodeID: response.data.budgetCodeID,
            purchaseTypeID: response.data.purchaseTypeID,
            isUrgent: response.data.isUrgent
        })
        setTitle("Edit Requisition");

        if (response.data.requisitionStatus == 3) {
            let userData = await services.getUserDetailsByRequisitionNo(response.data.requisitionNumber);
            setEnteredByUser(userData.data.enteredUserName);
            setCheckedByUser(userData.data.checkedUserName);
        }

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: response.data.groupID,
            estateName: factories[response.data.factoryID],
            requestDate: response.data.requestDate,
            requisitionNumber: response.data.requisitionNumber,
            budgetName: budgetCodes[response.data.budgetCodeID],
            purchaseTypeName: purchaseTypes[response.data.purchaseTypeID],
            isUrgent: response.data.isUrgent,
        })
    }

    async function generateRequisitionNumber() {
        let response = await services.generateRequisitionNumber(requisitionDetails.groupID, requisitionDetails.factoryID, date);

        if (response.statusCode === "Success") {
            setRequisitionNumber(response.data);
        }
        else {
            alert.error(response.message);
            setRequisitionNumber('');
        }
    }

    async function getAvailableQuantity() {
        let response = await services.getAvailableQuantity(requisitionDetails.groupID, requisitionDetails.factoryID, requisitionDetails.skuCategoryID, requisitionDetails.itemName);
        if (response.statusCode === "Success") {
            setAvailableQuantity(response.data.availableQuantity);
        }
        else {
            setAvailableQuantity(0);
        }
    }

    function handleClickEditTheRow(row, index) {
        setIsUpdate2(true)
        setRequisitionDetails({
            ...requisitionDetails,
            skuCategoryID: row.skuCategoryID,
            itemName: row.skuMappingID,
            deliveryWarehouseID: row.deliveryWarehouseID,
            availableQuantity: row.availableQuantity,
            requestAmount: row.requestedQuantity,
        })
        setAvailableQuantity(row.availableQuantity);
        const dataDelete = [...gridDatArray];
        const remove = index;
        dataDelete.splice(remove, 1);
        setGridDatArray([...dataDelete]);
        setReuisitionDetailsID(row.requisitionDetailsID)
    }

    function DeleteItem(index, row) {
        setDialogbox(true);
        setIndex(index)
        setRow(row);
    }

    async function confirmData() {
        setDialogbox(false);
        if (isUpdate) {
            if (gridDatArray.length >= 2) {
                let deleteModel = {
                    requisitionDetailsID: index.requisitionDetailsID,
                    modifiedBy: parseInt(tokenService.getUserIDFromToken())
                };
                const res = await services.DeleteRequisitionItem(deleteModel);
                if (res.statusCode === "Success") {
                    const dataDelete = [...gridDatArray];
                    dataDelete.splice(row, 1);
                    setGridDatArray(dataDelete);
                    alert.success('SKU deleted successfully');
                    if (dataDelete.length == 0) {
                        navigate('/app/itemRequisition/listing');
                    }
                } else {
                    alert.error(res.message);
                }
            } else {
                let deleteModel = {
                    requisitionDetailsID: index.requisitionDetailsID,
                    modifiedBy: parseInt(tokenService.getUserIDFromToken()),
                    requisitionID: decryptedIDD
                };
                const res = await services.DeleteRequisitionItemWithRequisition(deleteModel);
                if (res.statusCode === "Success") {
                    const dataDelete = [...gridDatArray];
                    dataDelete.splice(row, 1);
                    setGridDatArray(dataDelete);
                    alert.success('SKU deleted successfully');
                    if (dataDelete.length == 0) {
                        navigate('/app/itemRequisition/listing');
                    }
                } else {
                    alert.error(res.message);
                }
            }
        } else {
            const dataDelete = [...gridDatArray];
            dataDelete.splice(row, 1);
            setGridDatArray(dataDelete);
            alert.success('SKU deleted successfully');
        }
    }

    function cancelData() {
        setDialogbox(false);
    }

    async function addToGrid() {
        setIsUpdate2(false);
        console.log("itemName ", requisitionDetails.itemName);
        const response = await services.getSKUMeasuringUnit(requisitionDetails.itemName);
        const newModel = {
            skuCategoryName: SKUCategoryNames.find((item) => item.skuCategoryID === requisitionDetails.skuCategoryID).skuCategoryName,
            skuCategoryID: parseInt(requisitionDetails.skuCategoryID),
            skuMasterName: item.find((item) => item.skuMappingID === requisitionDetails.itemName).skuMasterName,
            skuMappingID: parseInt(requisitionDetails.itemName),
            skuMasterID: response ? response.data[0].skuMasterID : 0,
            skuMesuringUnit: response ? response.data[0].skuMesuringUnit : "-",
            availableQuantity: parseFloat(availableQuantity),
            requestedQuantity: parseFloat(requisitionDetails.requestAmount),
            deliveryWarehouseID: parseInt(requisitionDetails.deliveryWarehouseID),
            deliveryWarehouseName: deliveryWarehouses[requisitionDetails.deliveryWarehouseID],
            requisitionDetailsID: isUpdate2 ? requisitionDetailsID : 0
        };
        console.log("new model", newModel);
        const isDuplicate = gridDatArray.some(
            (row) =>
                row.skuCategoryID === newModel.skuCategoryID &&
                row.skuMasterID === newModel.skuMasterID &&
                row.skuMappingID === newModel.skuMappingID
        );

        if (isDuplicate) {
            alert.error('Cannot Add Duplicate SKU');
            return;
        }
        else {
            setGridDatArray([...gridDatArray, newModel]);
            if (isUpdate == true) {
                alert.success('Row Updated');
            }
        }
        setRequisitionDetails({
            ...requisitionDetails,
            deliveryWarehouseID: '0',
            itemName: '0',
            availableQuantity: '',
            requestAmount: '',
        });

        setAvailableQuantity('');

    }

    async function handleClickApprove() {
        if (requisitionStatus == 1 || requisitionStatus == 2) {
            const response = await services.approveRequisition(decryptedIDD, tokenService.getUserIDFromToken(), requisitionStatus);
            if (response.statusCode == 'Success') {
                alert.success(response.message)
                navigate('/app/itemRequisition/listing');
            }
            else {
                alert.error(response.message)
                navigate('/app/itemRequisition/listing');
            }
        }
        else {
            alert.error('Something went wrong')
            navigate('/app/itemRequisition/listing');
        }
    }

    async function handleClickReject() {
        const response = await services.rejectRequisition(decryptedIDD, tokenService.getUserIDFromToken());
        if (response.statusCode == 'Success') {
            alert.success(response.message)
            navigate('/app/itemRequisition/listing');
        }
        else {
            alert.error(response.message)
            navigate('/app/itemRequisition/listing');
        }
    }

    async function onSave() {
        if (isUpdate == true) {
            let updateModel = {
                requisitionID: decryptedIDD,
                requisitionDetails: gridDatArray,
                createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
            }
            let response = await services.updateRequisition(updateModel);
            if (response.statusCode == "Success") {
                alert.success("Requisition Update Successfully");
                navigate('/app/itemRequisition/listing');
            }
            else {
                alert.error("Error occured");
            }
        } else {
            let genaralModel = {
                groupID: parseInt(requisitionDetails.groupID),
                factoryID: parseInt(requisitionDetails.factoryID),
                requisitionNumber: requisitionNumber,
                budgetCodeID: parseInt(requisitionDetails.budgetCodeID),
                purchaseTypeID: parseInt(requisitionDetails.purchaseTypeID),
                isUrgent: requisitionDetails.isUrgent,
                requestDate: moment(date.toString()).format('').split('T')[0],
                expectedDate: moment(expectedDate.toString()).format('').split('T')[0],
                createdBy: tokenService.getUserIDFromToken(),
                statusTypeID: parseInt("1")
            }
            var res = await services.SaveRequisition(genaralModel, gridDatArray);
            if (res.statusCode == "Success") {
                alert.success(res.message);
                navigate('/app/itemRequisition/listing');
            }
            else {
                alert.error(res.message);
            }
        }
    }

    const handleCheckboxChange = (checked) => {
        setRequisitionDetails({
            ...requisitionDetails,
            isUrgent: checked,
        });
    };

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleClick}
                    />
                </Grid>
            </Grid>
        )
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title={title}
            >
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: requisitionDetails.groupID,
                            factoryID: requisitionDetails.factoryID,
                            budgetCodeID: requisitionDetails.budgetCodeID,

                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                                budgetCodeID: Yup.number().required('Account Code is required').min("1", 'Account Code is required'),
                            })
                        }
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            props
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={3}>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={requisitionDetails.groupID}
                                                            variant="outlined"
                                                            size="small"
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled || isUpdate || gridDatArray.length > 0,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            fullWidth
                                                            name="factoryID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={requisitionDetails.factoryID}
                                                            variant="outlined"
                                                            size="small"
                                                            InputProps={{
                                                                readOnly: !permissionList.isFactoryFilterEnabled || isUpdate || gridDatArray.length > 0,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateFactoryDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>
                                                            Request Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="date"
                                                                value={date}
                                                                onChange={(e) => {
                                                                    setDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                disabled={isUpdate || gridDatArray.length > 0}
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="requisitionNumber">
                                                            Requisition Number
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.requisitionNumber && errors.requisitionNumber)}
                                                            helperText={touched.requisitionNumber && errors.requisitionNumber}
                                                            fullWidth
                                                            size='small'
                                                            name="requisitionNumber"
                                                            onChange={(e) => handleChange(e)}
                                                            value={requisitionNumber}
                                                            variant="outlined"
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="budgetCodeID">
                                                            Account Code Name *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.budgetCodeID && errors.budgetCodeID)}
                                                            fullWidth
                                                            helperText={touched.budgetCodeID && errors.budgetCodeID}
                                                            size='small'
                                                            name="budgetCodeID"
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={requisitionDetails.budgetCodeID}
                                                            variant="outlined"
                                                            id="budgetCodeID"
                                                            InputProps={{
                                                                readOnly: isUpdate || gridDatArray.length > 0,
                                                            }}
                                                        >
                                                            {generateDropDownMenu(budgetCodes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>
                                                            Expected Date *
                                                        </InputLabel>
                                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                            <KeyboardDatePicker
                                                                autoOk
                                                                fullWidth
                                                                inputVariant="outlined"
                                                                format="dd/MM/yyyy"
                                                                margin="dense"
                                                                id="date"
                                                                value={expectedDate}
                                                                onChange={(e) => {
                                                                    setExpectedDate(e);
                                                                }}
                                                                KeyboardButtonProps={{
                                                                    'aria-label': 'change date',
                                                                }}
                                                                minDate={date}
                                                                disabled={isUpdate || gridDatArray.length > 0}
                                                                InputProps={{
                                                                    readOnly: true,
                                                                }}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    {/* <Grid item md={3} xs={12} >
                                                        <Box display="flex" alignItems="center" height="100%">
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={requisitionDetails.isUrgent}
                                                                        onChange={(e) => handleCheckboxChange(e.target.checked)}
                                                                        name="isUrgent"
                                                                        color="primary"
                                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                                        disabled={isUpdate}
                                                                    />
                                                                }
                                                                label="Is Urgent"
                                                                sx={{ my: 0 }}
                                                            />
                                                        </Box>
                                                    </Grid> */}

                                                </Grid>

                                            </CardContent>
                                            <Formik
                                                initialValues={{
                                                    requestAmount: requisitionDetails.requestAmount,
                                                    itemName: requisitionDetails.itemName,
                                                    skuCategoryID: requisitionDetails.skuCategoryID,
                                                    deliveryWarehouseID: requisitionDetails.deliveryWarehouseID,
                                                }}
                                                validationSchema={
                                                    Yup.object().shape({
                                                        requestAmount: Yup.number().required('Requested Quantity is required').min("1", 'Requested Quantity is required'),
                                                        itemName: Yup.number().required('SKU is required').min("1", 'SKU is required'),
                                                        skuCategoryID: Yup.number().required('SKU Category is required').min("1", 'SKU Category is required'),
                                                        deliveryWarehouseID: Yup.number().required('Delivery Warehouse is Required').min("1", 'Delivery Warehouse is required'),
                                                    })
                                                }
                                                enableReinitialize
                                                onSubmit={() => trackPromise(addToGrid())}
                                            >
                                                {({
                                                    errors,
                                                    handleBlur,
                                                    touched,
                                                    values,
                                                }) => (
                                                    <Form>
                                                        <Card style={{ padding: 20, marginTop: 20 }}>
                                                            <Grid container spacing={3}>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="skuCategoryID">
                                                                        SKU Category *
                                                                    </InputLabel>
                                                                    <Autocomplete
                                                                        options={SKUCategoryNames || []}
                                                                        getOptionLabel={(option) => option.skuCategoryName ? option.skuCategoryName.toString() : ""}
                                                                        value={(SKUCategoryNames && SKUCategoryNames.find((SKUCategoryName) => SKUCategoryName.skuCategoryID === requisitionDetails.skuCategoryID)) || null}
                                                                        onChange={(event, newValue) => {
                                                                            setRequisitionDetails((prev) => ({
                                                                                ...prev,
                                                                                skuCategoryID: newValue ? newValue.skuCategoryID : 0
                                                                            }));
                                                                        }}
                                                                        renderInput={(params) => (<TextField
                                                                            {...params}
                                                                            error={Boolean(touched.skuCategoryID && errors.skuCategoryID)}
                                                                            fullWidth
                                                                            helperText={touched.skuCategoryID && errors.skuCategoryID}
                                                                            variant="outlined"
                                                                            size="small"
                                                                            placeholder="--Select SKU Category--"
                                                                        />)}
                                                                        disabled={(isUpdate2 || (isUpdate && (requisitionStatus != 1) || isUpdate && !(permissionList.isUpdateEnabled)))}
                                                                    />
                                                                </Grid>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="itemName">
                                                                        SKU *
                                                                    </InputLabel>
                                                                    <Autocomplete
                                                                        options={item || []}
                                                                        getOptionLabel={(option) => option.skuMasterName ? option.skuMasterName.toString() : ""}
                                                                        value={(item && item.find((itemNameName) => itemNameName.skuMappingID === requisitionDetails.itemName)) || null}
                                                                        onChange={(event, newValue) => {
                                                                            setRequisitionDetails((prev) => ({
                                                                                ...prev,
                                                                                itemName: newValue ? newValue.skuMappingID : 0
                                                                            }));
                                                                        }}
                                                                        clearOnBlur={false}
                                                                        renderInput={(params) => (<TextField
                                                                            {...params}
                                                                            error={Boolean(touched.itemName && errors.itemName)}
                                                                            fullWidth
                                                                            helperText={touched.itemName && errors.itemName}
                                                                            variant="outlined"
                                                                            size="small"
                                                                            placeholder="--Select SKU --"
                                                                        />)}
                                                                        disabled={(isUpdate2 || (isUpdate && (requisitionStatus != 1) || isUpdate && !(permissionList.isUpdateEnabled)))}
                                                                    />
                                                                </Grid>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="deliveryWarehouseID">
                                                                        Delivery Warehouse *
                                                                    </InputLabel>
                                                                    <TextField select
                                                                        error={Boolean(touched.deliveryWarehouseID && errors.deliveryWarehouseID)}
                                                                        helperText={touched.deliveryWarehouseID && errors.deliveryWarehouseID}
                                                                        fullWidth
                                                                        name="deliveryWarehouseID"
                                                                        size='small'
                                                                        onChange={(e) => handleChange(e)}
                                                                        value={requisitionDetails.deliveryWarehouseID}
                                                                        variant="outlined"
                                                                        InputProps={{
                                                                            readOnly: (isUpdate && (requisitionStatus != 1) || isUpdate && !(permissionList.isUpdateEnabled)),
                                                                        }}
                                                                    >
                                                                        <MenuItem value="0">--Select Delivery Warehouse--</MenuItem>
                                                                        {generateDropDownMenu(deliveryWarehouses)}
                                                                    </TextField>
                                                                </Grid>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="availableQuantity">
                                                                        Available Quantity
                                                                    </InputLabel>
                                                                    <TextField
                                                                        error={Boolean(touched.availableQuantity && errors.availableQuantity)}
                                                                        helperText={touched.availableQuantity && errors.availableQuantity}
                                                                        fullWidth
                                                                        size='small'
                                                                        name="availableQuantity"
                                                                        onChange={(e) => handleChange(e)}
                                                                        value={availableQuantity ? (availableQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0'}
                                                                        variant="outlined"
                                                                        InputProps={{
                                                                            readOnly: true,
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item md={3} xs={12}>
                                                                    <InputLabel shrink id="requestAmount">
                                                                        Requested Quantity *
                                                                    </InputLabel>
                                                                    <TextField
                                                                        error={Boolean(touched.requestAmount && errors.requestAmount)}
                                                                        helperText={touched.requestAmount && errors.requestAmount}
                                                                        fullWidth
                                                                        size='small'
                                                                        name="requestAmount"
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                                                handleChange(e);
                                                                            }
                                                                        }}
                                                                        value={requisitionDetails.requestAmount}
                                                                        variant="outlined"
                                                                        InputProps={{
                                                                            readOnly: (isUpdate && (requisitionStatus != 1) || isUpdate && !(permissionList.isUpdateEnabled)),
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item md={12} xs={12}
                                                                    container
                                                                    direction="row"
                                                                    justify="flex-end"
                                                                    alignItems="center">
                                                                    <Button
                                                                        color="primary"
                                                                        type="submit"
                                                                        variant="contained"
                                                                        size='small'
                                                                        disabled={(isUpdate && (requisitionStatus != 1)) || (isUpdate && !permissionList.isUpdateEnabled) || requisitionNumber == ''}
                                                                    >
                                                                        {isUpdate2 == true ? 'Update' : 'Add'}
                                                                    </Button>
                                                                </Grid>
                                                                {gridDatArray.length > 0 ? (
                                                                    <Grid item xs={12}>
                                                                        <TableContainer>
                                                                            <Table aria-label="customized table">
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        <TableCell align="left">SKU Category</TableCell>
                                                                                        <TableCell align="left">SKU</TableCell>
                                                                                        <TableCell align="left">Delivery Warehouse</TableCell>
                                                                                        <TableCell align="right">Available Quantity</TableCell>
                                                                                        <TableCell align="right">Requested Quantity</TableCell>
                                                                                        <TableCell align="right">Mesuring Unit</TableCell>
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {gridDatArray.map((row, index) => (
                                                                                        <TableRow key={index}>
                                                                                            <TableCell align="left" style={{ borderBottom: 'none' }}>
                                                                                                {row.skuCategoryName}
                                                                                            </TableCell>
                                                                                            <TableCell align="left" style={{ borderBottom: 'none' }}>
                                                                                                {row.skuMasterName}
                                                                                            </TableCell>
                                                                                            <TableCell align="left" style={{ borderBottom: 'none' }}>
                                                                                                {row.deliveryWarehouseName}
                                                                                            </TableCell>
                                                                                            <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                {row.availableQuantity ? (row.availableQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                                                                                            </TableCell>
                                                                                            <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                {row.requestedQuantity ? (row.requestedQuantity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                                                                                            </TableCell>
                                                                                            <TableCell align="right" style={{ borderBottom: 'none' }}>
                                                                                                {row.skuMesuringUnit ? (row.skuMesuringUnit).toLocaleString('en-US') : '-'}
                                                                                            </TableCell>
                                                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                            {(requisitionStatus == 1) && isUpdate && permissionList.isUpdateEnabled || !isUpdate ?
                                                                                                <DeleteIcon
                                                                                                    style={{
                                                                                                        color: "red",
                                                                                                        marginBottom: "1rem",
                                                                                                        marginTop: "1rem",
                                                                                                        cursor: "pointer"
                                                                                                    }}
                                                                                                    size="small"
                                                                                                    onClick={!isUpdate2 ? () => DeleteItem(row, index) : undefined}


                                                                                                >
                                                                                                </DeleteIcon> : null}
                                                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                            {(requisitionStatus == 1) && isUpdate && permissionList.isUpdateEnabled || !isUpdate ?
                                                                                                <EditIcon
                                                                                                    style={{
                                                                                                        color: "#6C625B", marginBottom: "1rem",
                                                                                                        marginTop: "1rem", cursor: "pointer"
                                                                                                    }}
                                                                                                    size="small"
                                                                                                    onClick={!isUpdate2 ? () => handleClickEditTheRow(row, index) : undefined}

                                                                                                />

                                                                                                : null}

                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </Grid>
                                                                ) : null}
                                                                {dialogbox ? <AlertDialogWithoutButton confirmData={confirmData} cancelData={cancelData}
                                                                    IconTitle={"Delete"}
                                                                    headerMessage={"Are you sure you want to delete?"}
                                                                />
                                                                    : null
                                                                }
                                                                <br />
                                                            </Grid>
                                                            <br />
                                                        </Card>
                                                        <br />
                                                        <br />
                                                        {gridDatArray.length > 0 ?
                                                            <Box display="flex" justifyContent="flex-end" p={2}>
                                                                {isUpdate && (requisitionStatus == 1 || requisitionStatus == 2) && permissionList.isRejectEnabled ? <>
                                                                    <Button
                                                                        color="primary"
                                                                        variant="contained"
                                                                        onClick={() => handleClickReject()}
                                                                        className={classes.red}
                                                                    >
                                                                        Reject
                                                                    </Button> </> : null}
                                                                &nbsp;&nbsp;&nbsp;
                                                                <Button
                                                                    color="primary"
                                                                    variant="contained"
                                                                    onClick={() => onSave()}
                                                                    disabled={(isUpdate && (requisitionStatus != 1) || isUpdate && (!permissionList.isUpdateEnabled))}
                                                                >
                                                                    {isUpdate == true ? 'Update' : 'Save'}
                                                                </Button>
                                                                {isUpdate && ((requisitionStatus == 1 && permissionList.isSendToApproveEnabled) || (requisitionStatus == 2 && permissionList.isApproveEnabled)) ? <>
                                                                    &nbsp;&nbsp;&nbsp;
                                                                    <Button
                                                                        color="primary"
                                                                        variant="contained"
                                                                        onClick={() => handleClickApprove()}
                                                                        className={classes.green}
                                                                    >
                                                                        {requisitionStatus == 1 ? 'Send To Approve' : 'Approve'}
                                                                    </Button>
                                                                </> : null}

                                                                {requisitionStatus == 3 ? <>
                                                                    &nbsp;&nbsp;&nbsp;
                                                                    <ReactToPrint
                                                                        trigger={() => <Button
                                                                            color="primary"
                                                                            id="btnCancel"
                                                                            variant="contained"
                                                                            style={{ marginRight: '1rem' }}
                                                                            className={classes.colorCancel}
                                                                            size='small'
                                                                        >
                                                                            PDF
                                                                        </Button>}
                                                                        content={() => componentRef.current}
                                                                    />
                                                                    <div hidden={true}>
                                                                        <CreatePDF
                                                                            ref={componentRef}
                                                                            gridDatArray={gridDatArray}
                                                                            requisitionDetails={requisitionDetails}
                                                                            selectedSearchValues={selectedSearchValues}
                                                                            requisitionNumber={requisitionNumber}
                                                                            estateName={estateName}
                                                                            enteredByUser={enteredByUser}
                                                                            checkedByUser={checkedByUser} />
                                                                    </div>
                                                                </> : null}

                                                            </Box> : null}
                                                        <br />
                                                        <br />
                                                    </Form>)
                                                }
                                            </Formik>
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page >
        </Fragment>
    )
}
